import { Component, inject, HostListener, ElementRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { AppConfiguration, AppContainerService } from '@app-container';
import { Config } from '@config';


@Component({
    selector: 'ciu-dashboard',
    template: `
        <clx-app-container [config]="config"></clx-app-container>
    `,
    standalone: false
})
export class CiuDashboardComponent {

    containerService: AppContainerService = inject(AppContainerService);

    configService: Config = inject(Config);

    config: AppConfiguration;


    ngOnInit() {
        this.config = {
            name: 'CiuDashboard',
            source: this.configService.serverConfig.DEPLOYMENT === 'LOCAL'
                ? 'https://127.0.0.1:4200'
                : '/Content/CiuDashboard/index.html',
            origin: '*'
        }
    }
}